import { render } from "./website-phone.vue?vue&type=template&id=7e97d7fd&scoped=true"
import script from "./website-phone.vue?vue&type=script&lang=js"
export * from "./website-phone.vue?vue&type=script&lang=js"

import "./website-phone.vue?vue&type=style&index=0&id=7e97d7fd&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e97d7fd"]])

export default __exports__